export const PRESENTATION_SPACING_UNITS = 3 as const;
